import { ConfirmDialog } from "Components/Actions/ConfirmDialog";
import { WithTranslator } from "Components/Generic/Translator";
import { isTrue } from "Utils/Boolean";
import { IExportWithMissingRolesDialogProps } from "./IExportWithMissingRolesDialogProps";

export const ExportWithMissingRolesDialog = WithTranslator((props: IExportWithMissingRolesDialogProps): JSX.Element => {
  const {
    hidden, onConfirm, onDismiss, translator
  } = props;
  return (
    <ConfirmDialog
      hidden={isTrue(hidden, true)}
      title={translator.get(`export.confirm.title`, `Missing roles!`)}
      subText={translator.get(
        `export.confirm.text`,
        `Some companies do not have roles assigned. Do you really want to export companies without roles?`
      )}
      confirmButtonText={translator.get(`export.confirm.yes`, `Yes`)}
      onConfirm={onConfirm}
      dismissButtonText={translator.get(`export.confirm.no`, `No, please don't`)}
      onDismiss={onDismiss}
    />
  );
});
